<mat-card class="cardT">Novo Usuário</mat-card>
<form [formGroup]="createFormGroup" autocomplete="off">

  <div class="form-fields">
    <mat-form-field class="item edit-input edit-input-half-full-field" appearance="outline">
      <mat-label>Nome</mat-label>
      <input type="text" matInput formControlName="noNomeCompleto" autocomplete="off" />
    </mat-form-field>

    <mat-form-field class="item edit-input edit-input-half-full-field" appearance="outline">
      <mat-label>E-mail</mat-label>
      <input type="email" matInput formControlName="noEmail" autocomplete="off" />
    </mat-form-field>

    <mat-form-field class="item edit-input edit-input-half-full-field" appearance="outline">
      <mat-label>CPF</mat-label>
      <input type="text" matInput formControlName="noCpfj" mask="000.000.000-00" autocomplete="off"/>
    </mat-form-field>

    <mat-form-field class="item edit-input edit-input-half-full-field" appearance="outline">
      <mat-label>Celular</mat-label>
      <input type="text" matInput formControlName="nrCelular" mask="+00 (00) 00000-0000" autocomplete="off"/>
    </mat-form-field>

    <mat-form-field class="item edit-input edit-input-half-full-field" appearance="outline">
      <mat-label>Senha</mat-label>
      <input matInput [type]="hide ? 'password' : 'text'" formControlName="noSenha" autocomplete="new-password">
      <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
        [attr.aria-pressed]="hide">
        <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field class="item edit-input edit-input-half-full-field" appearance="outline" *ngIf="exibeCamposEasyMob">
      <mat-label>EasyMob Chave</mat-label>
      <input type="text" matInput formControlName="noEasyMobChave" autocomplete="off" />
    </mat-form-field>

    <mat-form-field class="item edit-input edit-input-half-full-field" appearance="outline" *ngIf="exibeCamposEasyMob">
      <mat-label>EasyMob Usuário</mat-label>
      <input type="text" matInput formControlName="noEasyMobUsuario" autocomplete="off" />
    </mat-form-field>

    <mat-form-field class="item edit-input edit-input-half-full-field" appearance="outline" *ngIf="exibeCamposEasyMob">
      <mat-label>EasyMob Senha</mat-label>
      <input matInput [type]="hide ? 'password' : 'text'" formControlName="noEasyMobSenha" autocomplete="new-password">
    </mat-form-field>

  </div>
  <div class="buttons">
    <button type="submit" color="primary" class="btn" mat-raised-button [disabled]="createFormGroup.invalid"
      (click)="onSalvar()"> Salvar </button>
    <button type="button" color="basic" class="btn" mat-raised-button routerLink="/usuarios"> Voltar </button>
  </div>
</form>

<div class="subscription" *ngIf="subscription">
  <div>
    <mat-spinner></mat-spinner>
    <p>Carregando...</p>
  </div>
</div>
